import axios from 'axios';
import { VehicleModel } from '../Models/VehicleModel';
import baseService from '../shared/baseService';

const vehicleService = () => baseService('vehicles');
const postVehicle = (params: VehicleModel) => axios.post('vehicles', params );
const vehicleExists = (params: VehicleModel) => axios.post('vehicles/exists', params );
const vehicleForClassification = (vehicleId: number) => axios.get(`vehicles/${vehicleId}/classification`);
const getVehicleByQuery = (name?: string | null, mediaId?: number, circulationId?: number) => {
    let query = '';

    if (name && name != '')
        query = `?vehicleNomenclature=${name}`;

    if (mediaId && mediaId > 0) {
        if (query == '')
            query = `?mediaId=${mediaId}`;
        else
            query += `&mediaId=${mediaId}`;
    }

    if (circulationId && circulationId > 0) {
        if (query == '')
            query = `?circulationId=${circulationId}`;
        else
            query += `&circulationId=${circulationId}`;
    }    
        
    return axios.get(`vehicles${query}`);
};

const getVehicleByMediaClient = (mediaId?: number, clientId?: number) => {
    let query = '';    

    if (mediaId && mediaId > 0) {
        if (query == '')
            query = `?mediaId=${mediaId}`;
        else
            query += `&mediaId=${mediaId}`;
    }

    if (clientId && clientId > 0) {
        if (query == '')
            query = `?clientId=${clientId}`;
        else
            query += `&clientId=${clientId}`;
    }
    
    return axios.get(`vehicles/client-media${query}`);
};

export default {
    vehicleService,
    getVehicleByQuery,
    postVehicle,
    vehicleForClassification,
    vehicleExists,
    getVehicleByMediaClient,
};

